import Entity from './entity'

export default class TestPaper extends Entity<string>{
    //试卷名称
    name: string;
    //类型章节中的节
    sectionId: number;
    //考试点数
    money: number = 0;
    //考试时间（分钟）
    examinationTime: number;
    creationTime: string;
    externalType: number = 2;
    notAllScore: number = 3;
    //试卷来源
    source: string;
    //试卷说明
    description: string;
    //试题范围所属章节
    rangeSectionChapters: string;
    //总题数
    totalQuestion: number = 0;
    //总分数
    totalFraction: number = 0;
    //试题类型和分数设置
    questionTypeAndFraction: string;
    //试题类型和数量设置
    questionTypeAndAmount: string;
    //组卷状态
    testPaperStatus: string;
    //是否激活
    isActive: boolean;
    //组卷是否完成
    iIsGroup: boolean;
    //完成次数
    numberOfExams: number;
    //试卷创建类型（1随机组卷，2手工组卷）
    testPaperCreateType: number;
    //试卷创建类型（1随机组卷，0手工组卷）
    handMadeRandom: number;
    //试卷选择范围(0综合练习，1单元测试)
    testPaperRange: number;
    //是否审核
    isAudited: boolean;
    isShow: boolean;
    gradeType: number;
    //级联选中
    categoryList: any;
    //发布者
    creatorUserName: string;
    //发布时间
    createionDay: string;
    //试卷中试题明细
    questionTypes: any
}